import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loadStatuses } from "root/js/variables";

import API from "../../js/api";

const initialState = {
  data: {},
  loadStatus: loadStatuses.fulfilled,
  dynamicsForPeriod: {
    product: {},
    colorDynamic: [],
    colorSizeDynamic: [],
    //sizeDynamic: [],
    brandSizeDynamic: [],
    warehousesDynamic: [],
    colorWarehouseDynamic: [],
    productKeywords: [],
    colorSizeDynamic2: [],
  },
  dynamicsForMonth: {
    product: {},
    productRelative: {},
    //colorDynamic: [],
    colorSizeDynamic: [],
    //sizeDynamic: [],
    brandSizeDynamic: [],
  },
  dynamicsFor2Weeks: {
    product: {},
  },
  isLoading: {
    isProductLoading: true,
    isProductForMonthLoading: true,
    isProductFor2WeeksLoading: true,
    isProductRelativeLoading: true,
    isColorDynamicLoading: true,
    isColorSizeDynamicLoading: false,
    isBrandSizeDynamicForPeriodLoading: true,
    isBrandSizeDynamicForMonthLoading: true,
    isWarehousesDynamicLoading: true,
    isColorWarehouseDynamicLoading: false,
    isProductKeywordsLoading: true,
  },
  //
  seller: {
    isLoading: false,
    data: {},
  },
};

const WBAPI = new API();

// Вспомогательная функция для обработки ответа (избегаем дублирования кода)
const processProduct = (response, fallbackData = {}) => {
  // Копируем, чтобы не мутировать исходный ответ
  const result = { ...(response?.results?.[0] || {}) };

  if (response?.results?.[0]) {
    result.imgs = response.results[0].images;
  }

  // Применяем фоллбэк если нужно
  const product = Object.keys(result).length > 0 ? result : { ...fallbackData };

  // Нормализуем images
  product.images = product.imgs
    ? (Array.isArray(product.imgs) ? product.imgs : [product.imgs])
        .filter(Boolean)
        .map(item => item?.url)
    : [product.imgs].filter(Boolean);

  return product;
};

export const fetchProductDynamic = createAsyncThunk(
  "productDynamics/fetchProductDynamic",
  async (obj, { rejectWithValue }) => {
    try {
      const { loadMonthData, load2WeeksData, ...params } = obj;
      const { date_from, date_to, ...restParams } = params;

      // Запускаем ВСЕ запросы к getProductsDynamic параллельно
      const mainPromise = WBAPI.getProductsDynamic(params);
      const monthPromise = loadMonthData
        ? WBAPI.getProductsDynamic({ ...restParams, period: 30 })
        : Promise.resolve(null);
      const twoWeeksPromise = load2WeeksData
        ? WBAPI.getProductsDynamic({ ...restParams, period: 14 })
        : Promise.resolve(null);
      // Ждём все ответы
      const [mainResponse, monthResponse, twoWeeksResponse] = await Promise.all([
        mainPromise,
        monthPromise,
        twoWeeksPromise,
      ]);

      // Логика фоллбэка
      let parserData = null;
      let dynamicsNotFound = false;

      // --- Обработка основного продукта ---
      let productData = processProduct(mainResponse);

      if (!mainResponse?.results?.[0]) {
        // Фоллбэк: запрашиваем parserData только если основной запрос пуст
        parserData = await WBAPI.getProductInfoByProduct_ids({ id: params.product_ids });
        dynamicsNotFound = true;
        productData = { ...parserData }; // переопределяем с данными парсера
      }
      if (dynamicsNotFound) productData.isParserData = true;
      const productForPeriod = { ...productData };

      // --- Обработка месяца ---
      let productForMonth;
      if (loadMonthData) {
        let monthData = processProduct(monthResponse);
        // Фоллбэк-логика: только если нет данных И нет parserData
        if (!monthResponse?.results?.[0] && !parserData) {
          parserData = await WBAPI.getProductInfoByProduct_ids({ id: params.product_ids });
          monthData = { ...parserData };
        } else if (!monthResponse?.results?.[0] && parserData) {
          monthData = { ...parserData };
        }
        productForMonth = monthData;
      }
      // --- Обработка 2 недель ---
      let productFor2Weeks;
      if (load2WeeksData) {
        let twoWeeksData = processProduct(twoWeeksResponse);
        // Та же фоллбэк-логика
        if (!twoWeeksResponse?.results?.[0] && !parserData) {
          parserData = await WBAPI.getProductInfoByProduct_ids({ id: params.product_ids });
          twoWeeksData = { ...parserData };
        } else if (!twoWeeksResponse?.results?.[0] && parserData) twoWeeksData = { ...parserData };
        productFor2Weeks = twoWeeksData;
      }
      return { productData, productForPeriod, productForMonth, productFor2Weeks };
    } catch (error) {
      console.error(error);
      return rejectWithValue({ error });
    }
  }
);

export const fetchProductRelative = createAsyncThunk(
  "productDynamics/fetchProductRelative",
  async (obj, { rejectWithValue }) => {
    try {
      const { item, ...params } = obj;

      let productRelativeForMonth;

      const { date_from, date_to, ...restParams } = params;
      productRelativeForMonth = await WBAPI.getProductRelative({ ...restParams, period: 30 });

      const response = await WBAPI.getProductColorDynamic({
        period: 30,
        limit: 1,
        item,
        extra_fields: ["price"].join(),
      });

      productRelativeForMonth = {
        ...productRelativeForMonth,
        colors_count: response?.count ?? 0,
      };

      return { productRelativeForMonth };
    } catch (error) {
      console.log(error);
      return { productRelativeForMonth: {} };
    }
  }
);

export const fetchColorDynamic = createAsyncThunk(
  "productDynamics/fetchColorDynamic",
  async (obj, { rejectWithValue }) => {
    try {
      const { ...params } = obj;

      let { results: colorDynamicForPeriod } = await WBAPI.getProductColorDynamic({ ...params });

      // const response = await WBAPI.getProductColorDynamic({...restParams, item: itemForMonth, period: 30})
      // const colorDynamicForMonth = response.results

      return { colorDynamicForPeriod };
    } catch (error) {
      console.log(error);
      return { colorDynamicForPeriod: [] };
    }
  }
);

// export const fetchColorSizeDynamic = createAsyncThunk(
// 	"productDynamics/fetchColorSizeDynamic",
// 	async (obj, {rejectWithValue}) => {
// 		try {
// 			const {...params} = obj
//
// 			const {results: colorSizeDynamicForPeriod} =  await WBAPI.getProductsColorSizeDynamic({...params})
//
// 			const {date_from, date_to, ...restParams} = params
// 			const response = await WBAPI.getProductsColorSizeDynamic({...restParams, period: 30})
// 			const colorSizeDynamicForMonth = response.results
//
// 			return {colorSizeDynamicForPeriod, colorSizeDynamicForMonth}
// 		} catch (error) {
// 			console.log(error)
// 			return {colorSizeDynamicForPeriod: [], colorSizeDynamicForMonth: []}
// 		}
// 	}
// )

export const fetchColorSizeDynamic = createAsyncThunk(
  "productDynamics/fetchColorSizeDynamic",
  async (obj, { rejectWithValue }) => {
    try {
      const { ...params } = obj;

      const { results: colorSizeDynamic } = await WBAPI.getProductsColorSizeDynamic({ ...params });

      return { colorSizeDynamic };
    } catch (error) {
      console.log(error);
      return { colorSizeDynamic: [] };
    }
  }
);

export const fetchBrandSizeDynamicForPeriod = createAsyncThunk(
  "productDynamics/fetchBrandSizeDynamicForPeriod",
  async (params, { rejectWithValue }) => {
    try {
      const { results: brandSizeDynamic } = await WBAPI.getBrandSizeDynamic({ ...params });

      return { brandSizeDynamic };
    } catch (error) {
      console.log(error);
      return { brandSizeDynamic: [] };
    }
  }
);

export const fetchBrandSizeDynamicForMonth = createAsyncThunk(
  "productDynamics/fetchBrandSizeDynamicForMonth",
  async (params, { rejectWithValue }) => {
    try {
      const { results: brandSizeDynamic } = await WBAPI.getBrandSizeDynamic({
        ...params,
        // period: 30,
      });

      return { brandSizeDynamic };
    } catch (error) {
      console.log(error);
      return { brandSizeDynamic: [] };
    }
  }
);

export const fetchWarehousesDynamic = createAsyncThunk(
  "productDynamics/fetchWarehousesDynamic",
  async (params, { rejectWithValue }) => {
    try {
      const warehousesDynamicForPeriod = await WBAPI.getWarehousesDynamic({
        ...params,
        extra_fields: params.extra_fields + ",turnover",
      });

      return { warehousesDynamicForPeriod };
    } catch (error) {
      console.log(error);
      return { warehousesDynamicForPeriod: [] };
    }
  }
);

export const fetchColorWarehouseDynamic = createAsyncThunk(
  "productDynamics/fetchColorWarehouseDynamic",
  async (params, { rejectWithValue }) => {
    try {
      const colorWarehouseDynamicForPeriod = await WBAPI.getProductsColorWarehouseDynamic({
        ...params,
      });

      return { colorWarehouseDynamicForPeriod };
    } catch (error) {
      console.log(error);
      return { colorWarehouseDynamicForPeriod: [] };
    }
  }
);

export const fetchProductKeywords = createAsyncThunk(
  "productDynamics/fetchProductKeywords",
  async (params, { rejectWithValue }) => {
    try {
      const { results: productKeywordsForPeriod } = await WBAPI.getProductKeywords({ ...params });

      return { productKeywordsForPeriod };
    } catch (error) {
      console.log(error);
      return { productKeywordsForPeriod: [] };
    }
  }
);

const productDynamicsSlice = createSlice({
  name: "productDynamics",
  initialState,
  reducers: {
    setIsLoading(state, { payload }) {
      state.isLoading = { ...state.isLoading, ...payload };
    },
    clearLoadStatuses(state) {
      state.isLoading = { ...initialState.isLoading };
    },
    setInitState() {
      return initialState;
    },
    resetProductDynamics(state, { payload }) {
      const resetForMonth = payload;

      return {
        ...initialState,
        dynamicsForMonth: resetForMonth ? initialState.dynamicsForMonth : state.dynamicsForMonth,
        dynamicsFor2Weeks: resetForMonth ? initialState.dynamicsFor2Weeks : state.dynamicsFor2Weeks,
        isLoading: {
          ...initialState.isLoading,
          isProductForMonthLoading: resetForMonth,
          isProductFor2WeeksLoading: resetForMonth,
        },
      };
    },
    // setAllLoading(state) {
    // 	state.isLoading = {
    // 		isProductLoading: true,
    // 		isProductRelativeLoading: true,
    // 		isColorDynamicLoading: true,
    // 		isColorSizeDynamicLoading: true,
    // 		isBrandSizeDynamicLoading: true,
    // 		isWarehousesDynamicLoading: true,
    // 		isColorWarehouseDynamicLoading: true
    // 	}
    // },
    setDynamicsForPeriod(state, { payload }) {
      state.dynamicsForPeriod = payload;
    },
    setDynamicsForMonth(state, { payload }) {
      state.dynamicsForMonth = payload;
    },
    setColorSizeDynamic(state, { payload }) {
      state.dynamicsForPeriod.colorSizeDynamic = payload;
      state.dynamicsForMonth.colorSizeDynamic = payload;
    },
    setProductSellerData(state, { payload: { key, value } }) {
      state.seller[key] = value;
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchProductDynamic.fulfilled, (state, { payload }) => {
      state.loadStatus = loadStatuses.fulfilled;
      if (payload.productData) state.data = payload.productData;
      if (payload.productForPeriod) {
        state.dynamicsForPeriod.product = payload.productForPeriod;
      }
      if (payload.productForMonth) {
        state.dynamicsForMonth.product = payload.productForMonth;
      }
      if (payload.productFor2Weeks) {
        state.dynamicsFor2Weeks.product = payload.productFor2Weeks;
      }
    });
    builder.addCase(fetchProductDynamic.pending, state => {
      state.loadStatus = loadStatuses.pending;
    });
    builder.addCase(fetchProductDynamic.rejected, (state, { payload }) => {
      state.loadStatus = loadStatuses.rejected;
      state.dynamicsForPeriod.product = {};
      state.dynamicsForMonth.product = {};
      state.dynamicsFor2Weeks.product = {};
      state.isLoading = getFalseIsLoadingObj(state.isLoading);
    });
    builder.addCase(fetchProductRelative.fulfilled, (state, { payload }) => {
      state.dynamicsForMonth.productRelative = payload.productRelativeForMonth || {};
      state.isLoading.isProductRelativeLoading = false;
    });
    builder.addCase(fetchColorDynamic.fulfilled, (state, { payload }) => {
      state.dynamicsForPeriod.colorDynamic = payload.colorDynamicForPeriod;
      state.isLoading.isColorDynamicLoading = false;
    });
    builder.addCase(fetchColorDynamic.rejected, (state, { payload }) => {
      state.dynamicsForPeriod.colorDynamic = [];
      state.isLoading.isColorDynamicLoading = false;
    });
    // builder.addCase(fetchColorSizeDynamic.fulfilled, (state, {payload}) => {
    // 	state.dynamicsForPeriod.colorSizeDynamic = payload.colorSizeDynamicForPeriod
    // 	state.dynamicsForMonth.colorSizeDynamic = payload.colorSizeDynamicForMonth
    // })
    builder.addCase(fetchColorSizeDynamic.pending, (state, { payload }) => {
      state.isLoading.isColorSizeDynamicLoading = true;
      state.dynamicsForPeriod.colorSizeDynamic = [];
    });
    builder.addCase(fetchColorSizeDynamic.fulfilled, (state, { payload }) => {
      state.dynamicsForPeriod.colorSizeDynamic = payload.colorSizeDynamic;
      state.isLoading.isColorSizeDynamicLoading = false;
    });
    builder.addCase(fetchColorSizeDynamic.rejected, (state, { payload }) => {
      state.isLoading.isColorSizeDynamicLoading = false;
    });
    builder.addCase(fetchBrandSizeDynamicForPeriod.fulfilled, (state, { payload }) => {
      state.dynamicsForPeriod.brandSizeDynamic = payload.brandSizeDynamic;
    });
    builder.addCase(fetchBrandSizeDynamicForMonth.pending, state => {
      state.isLoading.isBrandSizeDynamicForMonthLoading = true;
    });
    builder.addCase(fetchBrandSizeDynamicForMonth.fulfilled, (state, { payload }) => {
      state.dynamicsForMonth.brandSizeDynamic = payload.brandSizeDynamic;
      state.isLoading.isBrandSizeDynamicForMonthLoading = false;
    });
    builder.addCase(fetchWarehousesDynamic.fulfilled, (state, { payload }) => {
      state.dynamicsForPeriod.warehousesDynamic = payload.warehousesDynamicForPeriod;
    });

    builder.addCase(fetchColorWarehouseDynamic.pending, (state, { payload }) => {
      state.isLoading.isColorWarehouseDynamicLoading = true;
      state.dynamicsForPeriod.colorWarehouseDynamic = [];
    });
    builder.addCase(fetchColorWarehouseDynamic.fulfilled, (state, { payload }) => {
      state.dynamicsForPeriod.colorWarehouseDynamic = payload.colorWarehouseDynamicForPeriod;
      state.isLoading.isColorWarehouseDynamicLoading = false;
    });
    builder.addCase(fetchColorWarehouseDynamic.rejected, (state, { payload }) => {
      state.isLoading.isColorWarehouseDynamicLoading = false;
    });

    builder.addCase(fetchProductKeywords.fulfilled, (state, { payload }) => {
      state.dynamicsForPeriod.productKeywords = payload.productKeywordsForPeriod;
    });
  },
});

export const {
  setIsLoading,
  clearLoadStatuses,
  setColorSizeDynamic,
  resetProductDynamics,
  setInitState,
  setProductSellerData,
} = productDynamicsSlice.actions;

export default productDynamicsSlice.reducer;

const getFalseIsLoadingObj = loadObj => {
  const newLoadObj = { ...loadObj };
  for (const key in newLoadObj) {
    newLoadObj[key] = false;
  }
  return newLoadObj;
};
